import { api } from '../config/api';

export const userService = {
  getAll: async () => {
    return api.get('/api/users');
  },
  
  getById: async (id) => {
    return api.get(`/api/users/${id}`);
  },
  
  create: async (data) => {
    return api.post('/api/users', data);
  },
  
  update: async (id, data) => {
    return api.put(`/api/users/${id}`, data);
  },
  
  delete: async (id) => {
    return api.delete(`/api/users/${id}`);
  },
  
  toggleActive: async (id, isActive) => {
    return api.patch(`/api/users/${id}`, { is_active: isActive });
  },

  // F1/F2: the ONE path that changes another user's password — the proven
  // admin reset route (hashes once, clears login backoff, revokes the target's
  // sessions, audits, notifies). The profile PUTs never carry a password.
  resetPassword: async (id, password) => {
    return api.post(`/api/users/${id}/reset-password`, { password });
  }
};
